import React from "react";
import { Textfit } from "react-textfit";
import cn from "classnames";
import { useCustomT } from "../../hooks/useCustomT";
import withForceRerender from "../../HOC/withForceRerender";
import styles from "./CorrectAnswer.module.css";

import ResultPanelPicture from "../../images/result-panel-picture.png";

function CorrectAnswer({
  isAnswersWithIcons,
  correctAnswerImageUrl,
  correctAnswerCaption,
  correctAnswerAnswer,
  correctAnswerDescription,
}) {
  const customT = useCustomT();

  return (
    <>
      <div
        className={cn(
          styles.answerPanelContent,
          styles.correctAnswerPanelContent,
          isAnswersWithIcons ? styles.correctAnswerWithIconPanelContent : ""
        )}
      >
        {correctAnswerImageUrl ? (
          <div className={styles.correctAnswerImageWrapper}>
            <img src={ResultPanelPicture} alt="answer panel" />
            <div className={styles.correctAnswerImage}>
              <img
                src={correctAnswerImageUrl}
                alt={
                  correctAnswerCaption ? correctAnswerCaption : "correct answer"
                }
              />
            </div>
          </div>
        ) : (
          <Textfit
            min={46}
            max={58}
            className={cn(styles.answerTopText, styles.correctAnswerPanelTitle)}
          >
            <p>{customT(correctAnswerAnswer)}</p>
          </Textfit>
        )}
        {customT(correctAnswerDescription) && (
          <Textfit
            min={32}
            max={48}
            className={cn(
              styles.correctAnswerPanelText,
              correctAnswerImageUrl ? styles.correctAnswerWithIcon : ""
            )}
          >
            <p>{customT(correctAnswerDescription)}</p>
          </Textfit>
        )}
      </div>
    </>
  );
}

export default React.memo(withForceRerender(CorrectAnswer));
